<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    Change profile pictures
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
                <div class="col-xl-12 no-padding form-group">
                    <input type="file" name="file" id="file" class="inputfile" (change)="fileChangeEventPicture($event)" />
                    <label for="file" style="border: 1px solid lightgrey;border-radius: 5px;padding: 10px;">Browse from your computer</label>
                    <!--<input type="file" (change)="fileChangeEvent($event)" />-->
                </div>
                <div class=" col-xl-12">
                    <image-cropper [imageChangedEvent]="imageChangedEventPicture"
                                   [maintainAspectRatio]="true"
                                   [aspectRatio]="4 / 4"
                                   [resizeToWidth]="500"
                                   format="png"
                                   (imageCropped)="imageCroppedPicture($event)"
                                   (imageLoaded)="imageLoadedPicture()"
                                   (loadImageFailed)="loadImageFailedPicture()"></image-cropper>
                </div>
                <div class="col-xl-12 no-padding form-group">
                    <img [src]="croppedImagePicture" />
                </div>
                <div class="row">
                    <div class="col-xl-12 text-right">
                        <button [disabled]="btnSaveDisabledPicture" style="float: right;" (click)="saveProfilePicture()" class="btn mygistec-main-btn">{{btnSaveTextPicture}}</button>
                    </div>

                </div>
            </div>
        </div>
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    Change profile cover picture
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">

                <div class="col-xl-12 no-padding form-group">
                    <input type="file" name="file" id="fileCover" class="inputfile" (change)="fileChangeEventCover($event)" />
                    <label for="fileCover" style="border: 1px solid lightgrey;border-radius: 5px;padding: 10px;">Browse from your computer</label>
                    <!--<input type="file" (change)="fileChangeEvent($event)" />-->
                </div>
                <div class=" col-xl-12">
                    <image-cropper [imageChangedEvent]="imageChangedEventCover"
                                   [maintainAspectRatio]="true"
                                   [aspectRatio]="4 / 2"
                                   [resizeToWidth]="750"
                                   format="png"
                                   (imageCropped)="imageCroppedCover($event)"
                                   (imageLoaded)="imageLoadedCover()"
                                   (loadImageFailed)="loadImageFailedCover()"></image-cropper>
                </div>
                <div class="col-xl-12 no-padding form-group">
                    <img [src]="croppedImageCover" />
                </div>
                <div class="row">
                    <div class="col-xl-12 text-right">
                        <button [disabled]="btnSaveDisabledCover" style="float: right;" (click)="saveCoverPicture()" class="btn mygistec-main-btn">{{btnSaveTextCover}}</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
